// src/components/home/FounderStoryModal.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaTimes, FaCompass, FaUserGraduate, FaCode, FaRocket } from "react-icons/fa";
import "./FounderStoryModal.css";

const FounderStoryModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="bvh-story-modal-overlay" onClick={onClose}>
      <div className="bvh-story-modal-card" onClick={(e) => e.stopPropagation()}>
        {/* Top Header Strip */}
        <div className="bvh-story-header-strip">
          <div className="bvh-story-tag-pill">
            <FaUserGraduate /> Meet Vivek • Creator
          </div>
          <button className="bvh-story-close-btn" onClick={onClose} title="Close modal">
            <FaTimes />
          </button>
        </div>

        {/* Modal Main Title */}
        <div className="bvh-story-title-block">
          <h2 className="bvh-story-main-title">Building BodhAI from Scratch</h2>
          <p className="bvh-story-sub-text">
            A student developer's journey to reimagining AI-powered exam & practice portals.
          </p>
        </div>

        {/* Scrollable Story Body */}
        <div className="bvh-story-scroll-body">
          <div className="bvh-story-paragraph-card">
            <span className="bvh-story-p-icon"><FaUserGraduate /></span>
            <div>
              <h4>The Inspiration</h4>
              <p>
                Hey there! I'm Vivek, a student, developer, and creator behind BodhAI.
                BodhAI started as a simple idea: existing exam platforms were clunky, rigid, and lacked intelligent feedback for students preparing for tech roles.
              </p>
            </div>
          </div>

          <div className="bvh-story-paragraph-card">
            <span className="bvh-story-p-icon"><FaCode /></span>
            <div>
              <h4>The Execution</h4>
              <p>
                I set out to build an end-to-end platform that seamlessly combines proctored coding assessments with AI-curated MCQs, automated grading, and real-time execution.
              </p>
            </div>
          </div>

          <div className="bvh-story-paragraph-card">
            <span className="bvh-story-p-icon"><FaRocket /></span>
            <div>
              <h4>The V2 Beta Era</h4>
              <p>
                With BodhAI V2 Beta, we are introducing lightning-fast test engines, improved security monitors, and cleaner analytics. Thank you for joining us on this journey!
              </p>
            </div>
          </div>
        </div>

        {/* Pinned Modal Footer */}
        <div className="bvh-story-pinned-footer">
          <button className="bvh-story-btn secondary" onClick={onClose}>
            Close
          </button>
          <button
            className="bvh-story-btn primary"
            onClick={() => {
              onClose();
              navigate("/our-journey");
            }}
          >
            <FaCompass /> View Full Story →
          </button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(FounderStoryModal);
